import Add from "./Add";
import Edit from "./Edit";
import Copy from "./Copy";
import Delete from "./Delete";
import Save from "./Save";
import Cancel from "./Cancel";
import Logs from "./Logs";

export default {
	Add,
	Edit,
	Copy,
	Delete,
	Save,
	Cancel,
	Logs,
};



// WEBPACK FOOTER //
// ./src/Core/Components/Buttons/index.js